<!-- Модальное окно PDF, использующее то же содержимое, что и старая прямая ссылка. -->
<template>
  <BaseModal
    v-if="visible"
    :visible="true"
    title="Предпросмотр PDF"
    size="fullscreen"
    body-padding="none"
    @close="$emit('close')"
  >
    <EdoDocumentPdfPreview
      :document="document"
      :visible="pdfVisible"
      :pdf-pending-visible="pdfPendingVisible"
      :pdf-polling-hint="pdfPollingHint"
      :is-pdf-loading="isPdfLoading"
      :pdf-load-error="pdfLoadError"
      :pdf-preview-url="pdfPreviewUrl"
      @open-pdf="$emit('open-pdf')"
      @download-pdf="$emit('download-pdf')"
      @pdf-loaded="$emit('pdf-loaded')"
      @pdf-error="$emit('pdf-error', $event)"
      @refresh-pdf="$emit('refresh-pdf')"
    />
  </BaseModal>
</template>

<script>
import EdoDocumentPdfPreview from "@/components/Edo/DocumentPdfPreview.vue";

export default {
  name: "EdoDocumentPdfPreviewModal",

  components: {
    EdoDocumentPdfPreview,
  },

  props: {
    visible: { type: Boolean, default: false },
    document: { type: Object, required: true },
    pdfVisible: { type: Boolean, default: false },
    pdfPendingVisible: { type: Boolean, default: false },
    pdfPollingHint: { type: String, default: "" },
    isPdfLoading: { type: Boolean, default: false },
    pdfLoadError: { type: Boolean, default: false },
    pdfPreviewUrl: { type: String, default: "" },
  },

  emits: [
    "close",
    "open-pdf",
    "download-pdf",
    "pdf-loaded",
    "pdf-error",
    "refresh-pdf",
  ],
};
</script>
